// @flow
export const SELECT_THEME_API = {
  select: '',
  selectInput: '',
  input: '',
  isOpen: '',
  openUpward: '',
  errored: '',
  disabled: ''
};
